const _ = require('lodash');

const PastShopService = function PastShopService(restangular, $q, bootstrap) {
    this._pastshopRoute = restangular.one('pastshops');
    this.restangular = restangular;
    this.$q = $q;
    this.pastShops = [];
    this.noPastShopsMessage = '';
    this.selectedOrder = null;
    this.selectedOrderId = '';
    this.selectedOrderProductsCount = 0;

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.PastShops)) {
        this._setPastShops(bootstrap.getBootstrappedData(bootstrap.bootstrapped.PastShops));
    }
};

PastShopService.prototype._setPastShops = function (data) {
    this.pastShops = data.Response;
    this.noPastShopsMessage = data.NoPastShopsMessage;

    if (this.selectedOrderId && this.selectedOrderId !== 'everything') {
        this.selectedOrder = _.find(this.pastShops, { OrderId: parseInt(this.selectedOrderId) });
        this.selectedOrderProductsCount = this.selectedOrder.ProductsCount;
    }
    return this.pastShops;
};

PastShopService.prototype.listPastShops = function () {
    if (this.pastShops && this.pastShops.length) {
        return this.$q.when(this.pastShops);
    }

    return this._pastshopRoute.one('list').get().then(this._setPastShops.bind(this));
};

PastShopService.prototype.selectOrder = function (listProductsService, orderId) {
    this.selectedOrderId = orderId;
    listProductsService.suggestedListClickedPreviously = false;
    if (orderId === 'everything') {
        this.selectedOrder = null;
        this.selectedOrderProductsCount = 0;
    } else {

        if (!this.pastShops || this.pastShops.length === 0) {
            this.listPastShops();
        }

        if (this.pastShops && this.pastShops.length > 0) {
            this.selectedOrder = _.find(this.pastShops, { OrderId: parseInt(orderId) });
            this.selectedOrderProductsCount = this.selectedOrder
                ? this.selectedOrder.ProductsCount
                : 0;
        }
    }
};

function createArgs(args) {
    return {
        pageNumber: args.pageNumber,
        pageSize: args.pageSize || 10,
        sortType: args.sortType,
    };
}

function createArgsWithRrId(args) {
    const result = createArgs(args);
    result.richRelevanceId = args.richRelevanceId;
    result.isMobile = args.isMobile;
    return result;
}

PastShopService.prototype.getProductsForSelectedOrder = function (args) {
    if (this.selectedOrderId === null) {
        return null;
    }
    const getProducts = this.selectedOrderId === 'everything'
        ? this._pastshopRoute.doGET('AllProducts', createArgs(args))
        : this.restangular.one('pastshops', this.selectedOrderId).doGET('products', createArgs(args));
    return getProducts.then(response => ({
        items: response.Items,
        totalRecordCount: response.TotalRecordCount,
    }));
};

PastShopService.prototype.getSpecialProducts = function (args) {
    return this._pastshopRoute.doGET('AllSpecialProducts', createArgsWithRrId(args)).then(response => ({
        totalRecordCount: response.TotalRecordCount,
        items: response.Items,
        richRelevancePlacement: response.RichRelevancePlacement,
    }));
};

PastShopService.prototype.invalidate = function () {
    this.pastShops = [];
};

module.exports = PastShopService;



// WEBPACK FOOTER //
// ./src/common/pastshops/pastshop.service.js